import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'rk-stream-sort-dialog',
  templateUrl: './stream-sort-dialog.component.html',
  standalone: false,
})
export class StreamSortDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<StreamSortDialogComponent>,
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
